import { EntityState } from '@/api/resources/entityState/entity-state'
import { commonStatusService } from '@/api/services/common/status/common-status.service'
import { EntityStatusState, StoreStateModel } from '@/store/root/root-store.model'
import { keyBy, merge } from 'lodash'
import { store } from '@/store/store'

export const REQUEST_STATES = {
    DRAFT: { code: 'DRAFT', class: 'state-draft', order: 10 },
    REQUESTED: { code: 'REQUESTED', class: 'state-alt-primary', order: 20 },
    REGISTERED: { code: 'REGISTERED', class: 'state-primary', order: 30 },
    COMPLETED: { code: 'COMPLETED', class: 'state-success', order: 40 },
    LOCKED: { code: 'LOCKED', class: 'state-pending', order: 50 },
    RETURNED: { code: 'RETURNED', class: 'state-returned', order: 60 },
    CANCELED: { code: 'CANCELED', class: 'state-canceled', order: 70 }
}

class RequestState extends EntityState {
    protected get entityName(): string {
        return 'request'
    }

    async loadStates(): Promise<void> {
        if (!this.states.length) {
            const states = await commonStatusService.getRequestStates()
            const entityState: StoreStateModel<EntityStatusState[]> = {
                name: this.entityName,
                state: Object.values(
                    merge(
                        keyBy(states, 'code'),
                        keyBy(REQUEST_STATES, 'code')))
            }
            await store.dispatch('setEntityState', entityState)
        }
    }

    get statesWithoutDraft() {
        return this.states.filter(request => request.code !== REQUEST_STATES.DRAFT.code)
    }
}

export const requestState = new RequestState()
